import { defineComponent as _defineComponent } from 'vue'
import { NewBuyBoxView } from '@/stores/useUserStoreTypes';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { computed } from 'vue';
import { faTableCells, faList } from '@fortawesome/free-solid-svg-icons';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useBuyboxView } from '@/features/buybox/composables/useBuyboxView';
import { useMounted } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxTypeSwitcher',
  props: {
    additionalContexts: null,
    buyBoxType: null,
    title: null
  },
  emits: ["buyBoxTypeSwitched"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'buyBoxTypeSwitched', payload: { buyBoxType: NewBuyBoxView }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	additionalContexts: SnowplowContext[];
	buyBoxType?: NewBuyBoxView;
	title: TitleDetail;
};





const userStore = useUserStore();
const {
	setNewBuyboxTooltipAcknowledged,
	setNewBuyboxView,
	setBuyboxExpView,
	setBuyboxViewExpTooltipAcknowledged,
	setBuyboxFilterTypeOptimistic,
} = userStore;
const {
	newBuyboxTooltipAcknowledgedGetter,
	newBuyboxView,
	isUserFirstVisit,
	isLoggedIn,
	loggedInNewBuyboxView,

	// OLD BUYBOX EXP
	buyboxExpView,
	buyboxViewExpTooltipAcknowledged,
} = storeToRefs(userStore);

// OLD BUYBOX EXP
const { isGridBuyboxDefault } = useBuyboxView({ objectType: () => props.title.objectType });
// OLD BUYBOX EXP

const { t } = useI18n();

const isMounted = useMounted();

const buyboxView = computed(() => {
	if (!!props.buyBoxType) {
		return props.buyBoxType;
	}

	// OLD BUYBOX EXP
	if (isGridBuyboxDefault.value) return buyboxExpView.value;
	// OLD BUYBOX EXP

	if (isLoggedIn.value && (props.title.__typename === 'Season' || props.title.__typename === 'Show')) {
		return loggedInNewBuyboxView.value;
	}

	return newBuyboxView.value;
});

const showTooltip = computed(() => {
	if (!isMounted.value) return false;
	// OLD BUYBOX EXP
	if (isGridBuyboxDefault.value) {
		return !buyboxViewExpTooltipAcknowledged.value;
	}

	// OLD BUYBOX EXP
	if (isLoggedIn.value) {
		return !newBuyboxTooltipAcknowledgedGetter.value;
	}
	return !newBuyboxTooltipAcknowledgedGetter.value && isUserFirstVisit.value === false;
});

const handleListClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.LIST });
	} else {
		handleSetBuyboxView(NewBuyBoxView.LIST);
		handleSetTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.LIST);
	setBuyboxFilterTypeOptimistic(null);
};

const handleGridClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.GRID });
	} else {
		handleSetBuyboxView(NewBuyBoxView.GRID);
		handleSetTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.GRID);
	setBuyboxFilterTypeOptimistic(null);
};

function trackToggleEvent(label: NewBuyBoxView) {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_view_clicked', label }, props.additionalContexts);
}

function close() {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_switch_acknowledged' }, props.additionalContexts);
	handleSetTooltipAcknowledged();
}

// OLD BUYBOX EXP
function handleSetBuyboxView(viewType: NewBuyBoxView) {
	if (isGridBuyboxDefault.value) {
		setBuyboxExpView(viewType);
	} else {
		setNewBuyboxView(viewType);
	}
}

function handleSetTooltipAcknowledged() {
	if (isGridBuyboxDefault.value) {
		setBuyboxViewExpTooltipAcknowledged();
	} else {
		setNewBuyboxTooltipAcknowledged();
	}
}
// OLD BUYBOX EXP

return { __sfc: true,props, emit, userStore, setNewBuyboxTooltipAcknowledged, setNewBuyboxView, setBuyboxExpView, setBuyboxViewExpTooltipAcknowledged, setBuyboxFilterTypeOptimistic, newBuyboxTooltipAcknowledgedGetter, newBuyboxView, isUserFirstVisit, isLoggedIn, loggedInNewBuyboxView, buyboxExpView, buyboxViewExpTooltipAcknowledged, isGridBuyboxDefault, t, isMounted, buyboxView, showTooltip, handleListClicked, handleGridClicked, trackToggleEvent, close, handleSetBuyboxView, handleSetTooltipAcknowledged, faTableCells, faList }
}

})